/**
 * Turn selected Order Name options into purchase-order ids for the list filter.
 * One displayed name can represent several orders, so each option id may
 * already be a comma-separated list.
 * @param {Array<{id: string|number}>} selected Selected filter options.
 * @return {string} Comma-separated purchase-order ids.
 */
export const purchaseOrderIdsFromNameOptions = selected =>
  (selected || [])
    .flatMap(item => String(item.id).split(","))
    .map(id => id.trim())
    .filter(Boolean)
    .join(",");

export const purchaseOrderNameOptions = rows => {
  const orders = Array.isArray(rows) ? rows : rows?.results || [];
  const names = new Map();
  orders.forEach(({ id, user_reference }) => {
    if (!user_reference?.trim()) return;
    const ids = names.get(user_reference) || [];
    ids.push(id);
    names.set(user_reference, ids);
  });
  return Array.from(names, ([name, ids]) => ({ id: ids.join(","), name }));
};
